/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var lastScrollTop = 0;

  function watchNavigationScroll(e) {
    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();

  function updateTime() {
    var date = new Date();
    $('#current-time').text( date.getHours() + ':' + date.getMinutes() );
  }

  function fixVitruvianManPosition() {
    if( $(window).width() < 768 ) {
      $('.vitruvian-man').each(function() {
        var t = $(this);
        var child = $(this).find('> div');

        t.scrollLeft( ( child.outerWidth() - t.outerWidth() ) / 2 );
      });
    }
    else {
      $('.vitruvian-man').scrollLeft(0);
    }
  }
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('#navigation').on('show.bs.collapse', function() {
          $('body').addClass('nav-on');
        });

        $('#navigation').on('hide.bs.collapse', function() {
          $('body').removeClass('nav-on');
        });

        $('body').addClass('dom-loaded');

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        updateTime();

        setInterval(function() {
          updateTime();
        }, 10000);

        $('.section-quote-slider .quotes-slider, .section-vitruvian-man .quotes-slider').each(function() {
          var t = $(this);

          t.slick({
            dots: true,
            arrows: true,
            appendArrows: t.closest('section').find('.quote-slider-wrapper')
          });
        });

        $('.timeline-carousel').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.closest('.timeline-entry').find('.timeline-carousel-wrapper'),
              appendDots: t.closest('.timeline-entry').find('.timeline-carousel-wrapper')
            });
          }
        });

        $('.section-text-with-image .images-carousel').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              dots: true,
              arrows: true
            });
          }
        });

        $('.section-sliderable-content .content-slider').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              dots: true,
              arrows: true,
              appendArrows: t.siblings('.slider-controls'),
              appendDots: t.siblings('.slider-controls')
            });
          }
        });

        $('.section-sliderable-content .content-slider-2-col').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              dots: true,
              arrows: true
            });
          }
        });

        $('.section-sliderable-content .images-carousel').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.closest('.images-carousel-wrapper'),
              appendDots: t.closest('.images-carousel-wrapper')
            });
          }
        });

        $('.section-sliderable-content .quotes-carousel').each(function() {
          var t = $(this);
          var count = parseInt( t.attr('data-count') );

          if( count > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.closest('.quotes-carousel-wrapper'),
              appendDots: t.closest('.quotes-carousel-wrapper')
            });
          }
        });

        var wow = new WOW(
          {
            boxClass: 'wow',      // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 70,          // distance to the element when triggering the animation (default is 0)
            mobile: true,       // trigger animations on mobile devices (default is true)
            live: true,       // act on asynchronously loaded content (default is true)
            callback: function (box) {
              $(box).addClass('appeared');
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
          }
        );
        wow.init();

        $(document).on('click', '.side-menu-toggle', function(e) {
          e.preventDefault();

          $('body').toggleClass('side-menu-on');
          $('body').removeClass('scrolled');
        });

        $(document).on('click', '.video-wrapper .video-toggle', function(e) {
          e.preventDefault();

          var t = $(this);
          var modal = $('#global-video-popup');

          var video_clone = t.siblings('video').clone();

          modal.find('.modal-body').html( video_clone );

          modal.find('video').attr('controls', 'true');

          modal.modal('show');
        });

        $('#global-video-popup').on('shown.bs.modal', function (e) {
          var video = $('#global-video-popup video');

          if( video.length ) {
            video = video.get(0);
            video.play();
          }
        });

        $('#global-video-popup').on('hide.bs.modal', function (e) {
          var video = $('#global-video-popup video');

          if( video.length ) {
            video = video.get(0);
            video.pause();
          }
        });

        // $(document).on('click', '.video-wrapper .video-toggle', function(e) {
        //   e.preventDefault();

        //   var t = $(this);
        //   var video_wrapper = t.closest('.video-wrapper');
        //   var video = video_wrapper.find('video');

        //   if( video.length ) {
        //     video = video.get(0);

        //     if( video_wrapper.hasClass('video-playing') ) {
        //       video_wrapper.removeClass('video-playing');
        //       video.pause();
        //     }
        //     else {
        //       video_wrapper.addClass('video-playing');
        //       video.play();
        //     }
        //   }
        // });

        $(document).on('click', '.reveal-truncated-text', function(e) {
          e.preventDefault();

          $(this).hide().siblings('.truncated-text').removeClass('truncated-text');
        });

        $('.modal').appendTo('body');

        $('.global-popup').each(function() {
          var t = $(this);
          var id = t.attr('id');

          $(document).on('click', 'a[href="#' + id + '"]', function(e) {
            if( !$(this).attr('data-bs-toggle') || ( $(this).attr('data-bs-toggle') !== 'modal' ) ) {
              e.preventDefault();
              t.modal('show');
            }
          });
        });

        $('.section-media-slider').each(function() {
          var t = $(this);
          var idx = t.attr('data-idx');

          var atts = {
            autoplay: false,
            dots: true,
            arrows: true,
            appendArrows: t.find('.slider-controls'),
            appendDots: t.find('.slider-controls')
          };

          if( t.find('.slider-controls-wrapper.with-buttons').length ) {
            atts.asNavFor = 'section[data-idx="' + idx + '"] .slider-buttons-wrapper';

            t.find('.slider-buttons-wrapper').slick({
              autoplay: false,
              dots: false,
              arrows: false,
              asNavFor: 'section[data-idx="' + idx + '"] .media-slider'
            });
          }

          t.find('.media-slider').slick( atts );
        });

        $('.section-content-slider-background .content-column[data-content-type="content-slider"] .content-slider').each(function() {
          var t = $(this);

          if( t.find('.item-slide').length > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.siblings('.content-slider-controls'),
              appendDots: t.siblings('.content-slider-controls')
            });
          }
        });

        $('.section-slider-with-categories .images-carousel-wrapper').each(function() {
          var t = $(this);

          if( t.find('.item-slide').length > 1 ) {
            t.slick({
              infinite: false,
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.closest('.media-article').find('> div'),
              appendDots: t.closest('.media-article').find('.slider-controls')
            });
          }
        });

        if( $('.section-slider-with-categories[data-display-layout="masonry"] .media-articles-grid').length ) {
          $('.section-slider-with-categories[data-display-layout="masonry"] .media-articles-grid').each(function() {
            var t = $(this);

            t.isotope({
              itemSelector: '.media-article',
              percentPosition: true,
              transitionDuration: 0,
              masonry: {
                columnWidth: '.grid-sizer'
              }
            });
          });

          $('.section-slider-with-categories[data-display-layout="masonry"]').each(function() {
            $(this).find('.media-articles-grid').eq(0).addClass('on').find('.slick-slider').slick('setPosition');
          });
        }

        if( $('.section-slider-with-categories[data-display-layout="slider"] .media-articles-grid').length ) {
          $('.section-slider-with-categories[data-display-layout="slider"] .media-articles-grid').each(function() {
            var t = $(this);

            t.slick({
              infinite: false,
              slidesToShow: 3,
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.siblings('.bottom-carousel-controls'),
              appendDots: t.siblings('.bottom-carousel-controls'),
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1
                  }
                },
              ]
            });
          });

          $('.section-slider-with-categories[data-display-layout="slider"]').each(function() {
            $(this).find('.media-articles-grid').eq(0).addClass('on').slick('setPosition');
          });
        }

        $('.section-slider-with-categories [data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
          // e.target // newly activated tab
          // e.relatedTarget // previous active tab

          var target = $( $(e.target).attr('data-bs-target') );

          target.siblings().find('.media-articles-grid').removeClass('on');

          target.find('.media-articles-grid').addClass('on');

          if( target.closest('[data-display-layout="masonry"]').length ) {
            target.find('.media-articles-grid').isotope('layout');
          }

          setTimeout(function() {
            target.find('.slick-slider').slick('setPosition');
          }, 100);
        });

        $('.section-mswt .media-slider').each(function() {
          var t = $(this);

          if( t.find('.item-slide').length > 1 ) {
            t.slick({
              autoplay: false,
              dots: true,
              arrows: true,
              appendArrows: t.closest('section').find('.slider-controls'),
              appendDots: t.closest('section').find('.slider-controls')
            });
          }
        });

        $('.section-sliderable-content-2 .sliderable-content').each(function() {
          var t = $(this);

          if( t.find('.item-slide').length > 1 ) {
            t.slick({
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: true,
              appendArrows: t.closest('section').find('.slider-controls'),
              appendDots: t.closest('section').find('.slider-controls'),
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1
                  }
                }
              ]
            });
          }
        });

        $(document).on('click', '.menu-backdrop', function(e) {
          e.preventDefault();

          $('body').removeClass('side-menu-on');
        });

        $('[data-bs-toggle="tooltip"]').tooltip();

        $('.video-popup-show').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false
        }); 

        // $('.images-carousel-wrapper').each(function(i, v) {
        //   var t = $(this);

        //   t.attr('data-gallery-idx', i);

        //   $('[data-gallery-idx="'+i+'"]').magnificPopup({
        //     delegate: '.image-modal-open',
        //     type: 'image',
        //     closeOnContentClick: false,
        //     closeBtnInside: false,
        //     mainClass: 'mfp-with-zoom mfp-img-mobile',
        //     image: {
        //       verticalFit: true,
        //     },
        //     gallery: {
        //       enabled: true
        //     }
        //   });
        // });

        if( $('.vitruvian-man').length ) {
          fixVitruvianManPosition();

          $(window).on('load resize orientationchange', function() {
            setTimeout(function() {
              fixVitruvianManPosition();
            }, 100);
          });
        }

        $('.slick-slider').slickLightbox({
          itemSelector: '.image-modal-open',
          lazy: true,
        });

        $('.slick-slider').on({
          'show.slickLightbox': function(){
            $('.slick-lightbox').addClass('frontend');
          },
        });

        watchSlickDots();

        $(window).on('resize', function() {
          watchSlickDots();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
